import { ParamMap, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { RouteNames } from '../constants/route-names';
import { UserRole } from '../models/users/subrise-user.model';

/**
 * Sends the visitor to login. A signed-out visitor keeps the URL they asked for, so login can
 * take them there; a signed-in user without access gets none, as it would only bounce them back.
 */
export function loginUrlTree(router: Router, state: RouterStateSnapshot, roles: UserRole[]): UrlTree {
  const queryParams = roles.length === 0 ? { returnUrl: state.url } : undefined;
  return router.createUrlTree([RouteNames.LOGIN_ROUTE], { queryParams });
}

/** The requested URL, only when it is a path within this app, so it can't redirect off-site. */
export function readReturnUrl(params: ParamMap): string | null {
  const url = params.get('returnUrl');
  return url?.startsWith('/') && !url.startsWith('//') && !url.startsWith('/\\') ? url : null;
}
